(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    const formElement = document.querySelector("[data-product-form-regular]");
    const sentinel = document.querySelector("[data-product-form-sentinel]");
    const footer = document.querySelector("footer");

    if (!formElement || !sentinel) return;

    const isMobile = () => window.innerWidth < 768;

    let sentinelOutofView = false;
    let footerInView = false;

    const updateStickyState = () => {
      if (!isMobile()) {
        formElement.classList.remove("is-sticky-bar");
        return;
      }

      if (sentinelOutofView && !footerInView) {
        formElement.classList.add("is-sticky-bar");
      } else {
        formElement.classList.remove("is-sticky-bar");
      }
    };

    const observerOptions = {
      root: null,
      rootMargin: "10px 0px 10px 0px", 
      threshold: 0,
    };

    // Tracks if we scrolled past original form position
    const sentinelObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sentinelOutofView = !entry.isIntersecting;
        updateStickyState();
      });
    }, observerOptions);

    sentinelObserver.observe(sentinel);

    // Tracks if footer is entering/leaving viewport
    if (footer) {
      const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          footerInView = entry.isIntersecting;
          updateStickyState();
        });
      }, {
        root: null,
        rootMargin: "0px 0px 10px 0px", 
        threshold: 0
      });

      footerObserver.observe(footer);
    }

    window.addEventListener("resize", () => {
      if (!isMobile()) {
        formElement.classList.remove("is-sticky-bar");
      } else {
        updateStickyState();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
